// MST
import { types } from 'mobx-state-tree'

// Interfaces
import { QUESTION_TYPES } from 'constant/shared.constant'

// Helper
import { withHelper_commonLoadingModel } from './common.helper'

// Types
const { model, maybeNull, enumeration, number, string, boolean } = types

export const withHelper_questionModel = model('Question').props({
  questionId: maybeNull(number),
  isQuestionTableBordered: maybeNull(boolean),
  isQuestionBordered: maybeNull(boolean),
  question: maybeNull(string),
  questionFileUrl: maybeNull(string),
  questionType: maybeNull(enumeration('QuestionType', Object.values(QUESTION_TYPES))),

  // For Front-End Only
  loading: withHelper_commonLoadingModel,
})
